class ServerCommunicator {
	static mutualBaseURL = '/api/';
	
	static async doRequest(config: Object, extension: string, withJson : boolean = true): Promise<any> {
		const response = await fetch(this.mutualBaseURL + extension, config);

		if(withJson){
			if (!response.ok) {
				throw response;
			}
			return await response.json()
		}
		else{
			if (!response.ok) {
				throw response;
			}
			return response
		}
	}
}

export default ServerCommunicator;
